import {HTTP} from '@/CallAPI'
export default {
  organizationReport (organization, data) {
    return HTTP.post('checklists/' + organization.id + '/reports', data)
  },
  hashtagReport (data) {
    return HTTP.post('checklists/hashtag/reports', data)
  },
  getReportFix (checklist) {
    return HTTP.get('/checklists/' + checklist.id + '/report-fixes')
  }
}



// WEBPACK FOOTER //
// ./src/service/report.js